"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _localToken = require("../local-token");
var _contextTypes = _interopRequireDefault(require("../context-types"));
var _utils = require("../lib/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TokenManager = /*#__PURE__*/function (_React$Component) {
  _inherits(TokenManager, _React$Component);
  var _super = _createSuper(TokenManager);
  function TokenManager(props) {
    var _this;
    _classCallCheck(this, TokenManager);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      refreshing: false
    });
    _defineProperty(_assertThisInitialized(_this), "isRefreshingInIframe", false);
    _defineProperty(_assertThisInitialized(_this), "refresh", function () {
      console.log('should refresh access_token...');
      var _this$context = _this.context,
        provider = _this$context.provider,
        clientId = _this$context.clientId;
      var state = 'refreshing-' + Math.random();
      var query = {
        client_id: clientId,
        response_type: 'token',
        redirect_uri: window.location,
        state: state
      };
      var url = "".concat(provider, "/authorize?").concat((0, _utils.hashed)(query));
      _this.setState({
        refreshing: true,
        url: url,
        state: state
      });
      _this.setInterval();
    });
    _defineProperty(_assertThisInitialized(_this), "clearTimer", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = undefined;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setTimer", function (delay) {
      _this.timer = setTimeout(_this.refresh, delay);
    });
    _defineProperty(_assertThisInitialized(_this), "setInterval", function () {
      _this.interval = setInterval(_this.checkForNewToken, 500);
    });
    _defineProperty(_assertThisInitialized(_this), "clearInterval", function () {
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = undefined;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "checkForNewToken", function () {
      try {
        var iframeDoc = _this.iframe && _this.iframe.childNodes && _this.iframe.childNodes.length > 0 && _this.iframe.childNodes[0] && _this.iframe.childNodes[0].contentDocument;
        var valueInIFrame = function valueInIFrame(id) {
          return iframeDoc && iframeDoc.getElementById(id) && iframeDoc.getElementById(id).innerHTML;
        };
        var token = valueInIFrame('token');
        var expires_in = valueInIFrame('expires_in');
        if (token && expires_in) {
          console.log('got new token', token, expires_in);
          _this.clearInterval();
          _this.handleTokenUpdate(token, expires_in);
          _this.setRefreshTimer(expires_in);
          _this.setState({
            refreshing: false
          });
        } else {
          console.log('checked for new token, not found yet');
        }
      } catch (e) {
        _this.clearInterval();
        _this.setRefreshTimer("60"); // try again in 60 seconds
        _this.setState({
          refreshing: false
        });
        console.log('exception in checkForNewToken', e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderIframe", function () {
      var _this$state = _this.state,
        refreshing = _this$state.refreshing,
        url = _this$state.url;
      if (refreshing) {
        return {
          __html: "<iframe src=\"".concat(url, "\"></iframe>")
        };
      } else {
        return {
          __html: "not refreshing..."
        };
      }
    });
    // 60 seconds before token expires?
    _defineProperty(_assertThisInitialized(_this), "getDelay", function (expires_in) {
      return Number(expires_in) * 1000 - 60 * 1000;
    });
    _defineProperty(_assertThisInitialized(_this), "setRefreshTimer", function (expires_in) {
      console.log('setRefreshTimer, expires_in', expires_in);

      // 60 seconds before expiry
      var delay = _this.getDelay(expires_in);
      _this.clearTimer();
      _this.setTimer(Math.max(delay, 4000));
    });
    var hashValues = (0, _utils.getHashValues)();
    if (hashValues.access_token) {
      _this.state = {
        token: hashValues.access_token,
        expires_in: hashValues.expires_in
      };
    }
    return _this;
  }
  _createClass(TokenManager, [{
    key: "handleTokenUpdate",
    value: function handleTokenUpdate(token, expires_in) {
      (0, _localToken.setLocalToken)(token, expires_in);
      if (this.props.onTokenUpdate) {
        this.props.onTokenUpdate(token);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var localExpiresAt;
      if ((0, _localToken.getLocalToken)() && (localExpiresAt = (0, _localToken.getLocalExpiresAt)())) {
        this.setRefreshTimer((localExpiresAt.getTime() - new Date().getTime()) / 1000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
      this.clearInterval();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var results = (0, _utils.getHashValues)();
      if (results.access_token) {
        var expires_in = results.expires_in,
          state = results.state,
          access_token = results.access_token;
        this.handleTokenUpdate(access_token, expires_in);
        // We can refresh only if we get `expires_in` from the server
        // and, if state contains 'refreshing', then we are inside the
        // iframe, and therefore must break recursion
        if (state && state.match(/^refreshing/)) {
          this.isRefreshingInIframe = true;
        }
        if (expires_in && !this.isRefreshingInIframe) {
          // expires_in = "75" // for testing
          this.setRefreshTimer(expires_in);
        }
        window.location.hash = "";
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'none'
        }
      }, this.isRefreshingInIframe && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "token"
      }, this.state.token), /*#__PURE__*/_react["default"].createElement("div", {
        id: "expires_in"
      }, this.state.expires_in)), this.state.refreshing && /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(iframe) {
          _this2.iframe = iframe;
        },
        dangerouslySetInnerHTML: this.renderIframe()
      }));
    }
  }]);
  return TokenManager;
}(_react["default"].Component);
TokenManager.contextType = _contextTypes["default"];
var _default = TokenManager;
exports["default"] = _default;
//# sourceMappingURL=token-manager.js.map